import { IDefaultMappingDetails } from '@modules/accounting-and-finance/interface/default-mapping/default-mapping-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IDefaultMappingDetails[] = [];

export const ACCGDefaultMappingListSlice = createSlice({
  name: 'accgDefaultMappingList',
  initialState,
  reducers: {
    setACCGDefaultMappingList: (
      _state,
      action: PayloadAction<IDefaultMappingDetails[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGDefaultMappingList: () => {
      return initialState;
    },
  },
});

export default ACCGDefaultMappingListSlice.reducer;

export const { setACCGDefaultMappingList, removeACCGDefaultMappingList } =
  ACCGDefaultMappingListSlice.actions;
